/*
 * Totter + Tumble – Back in stock form (Klaviyo) – Version C
 *
 * Version C = Version B plus, on the thank-you screen:
 *  - "Add your email too?" (after a phone sign-up) or "Add your mobile too?"
 *    (after an email sign-up). Adds the second channel to the same alert and
 *    the same Klaviyo profile.
 *  - "Don't want to wait?" – up to 3 best-selling designs from the same colour
 *    collection that are in stock in the size they registered for. Uses
 *    sections/nm-recs.liquid; falls back to Shopify's related products.
 *
 * Works with snippets/notify-me-modal.liquid (Version C):
 *  - SMS + WhatsApp is the default channel; customers can switch to Email.
 *    Only the chosen channel's field is shown and validated.
 *  - Sold-out sizes are shown as tickable buttons; in-stock sizes are listed
 *    in a short note underneath. One Klaviyo back-in-stock subscription is
 *    created per ticked size.
 *  - Country code defaults to the shopper's store country (UK = +44).
 *  - Phone sign-ups must tick the consent box (Klaviyo requires SMS consent
 *    to send back in stock texts). Email marketing opt-in stays optional.
 *  - Which phone channels are used is set on the form element:
 *      data-phone-channels="SMS,WHATSAPP"  (UK)
 *      data-phone-channels="WHATSAPP"      (EU)
 *      data-phone-channels="SMS"           (US, default if missing)
 *  - Any link to "#notify-me" (or a product URL ending in #notify-me)
 *    opens the pop-up, even when the "Sold out" button is hidden.
 */

(function () {
  /* ---------- Settings you can change ---------- */
  var SIZE_ORDER = ['XL', 'Standard', 'Compact', 'Round', 'Runner']; // display order
  var LINK_HASH = '#notify-me';
  var TEXT = {
    sizeHeading: 'Which size?',
    sizeHint: 'Tick all that apply',
    inStockNote: function (list) { return list + (list.indexOf(' and ') > -1 || list.indexOf(',') > -1 ? ' are' : ' is') + ' in stock now.'; },
    allInStock: 'Good news – every size is in stock right now.',
    noSize: 'Please choose at least one size',
    badPhone: 'Please check your mobile number (no need to add the country code)',
    noCountry: 'Please choose your country code',
    badEmail: 'Please enter a valid email address',
    needConsent: function (label) { return 'Please tick the box so we can send alerts by ' + label; },
    failed: 'Sorry, something went wrong. Please check your details and try again.',
    successPhone: function (label, sizes) { return "We'll notify you when " + sizes + ' is back in stock.'; },
    successEmail: function (sizes) { return "We'll notify you when " + sizes + ' is back in stock.'; },
    extraEmailTitle: "Make sure you don't miss it",
    extraEmailSub: "Add your email and we'll let you know there too.",
    extraEmailBtn: 'Add my email',
    extraEmailDone: "Added – we'll email you too.",
    extraPhoneTitle: function (label) { return 'Hear about it the second it lands'; },
    extraPhoneSub: function (label) { return "Add your mobile and we'll message you by " + label + ' too.'; },
    extraPhoneBtn: 'Add my mobile',
    extraPhoneDone: function (label) { return "Added – we'll message you by " + label + ' too.'; },
    recsSubColour: function (size, colour) { return 'These ' + size + ' designs in ' + colour + ' are in stock now – you may love them too.'; },
    recsSub: function (size) { return 'These ' + size + ' designs are in stock now – you may love them too.'; },
    recsCount: 3
  };
  /* ---------------------------------------------- */

  function shortSizeLabel(title) {
    // "Play Runner Size | 180 x 65cm" -> "Runner", "XL Size | 250 x 150cm" -> "XL"
    return title.split(' Size')[0].split('|')[0].replace(/^Play\s+/i, '').trim();
  }

  function joinList(items) {
    if (items.length <= 1) return items.join('');
    return items.slice(0, -1).join(', ') + ' and ' + items[items.length - 1];
  }

  function productHandle() {
    var match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return match ? match[1] : null;
  }

  /* ---------- Open the pop-up from any link ---------- */
  function openNotifyMe() {
    var modal = document.querySelector('product-modal.notify-me-modal');
    if (!modal) return false;
    var dialog = modal.querySelector('dialog');
    var trigger = modal.querySelector('[data-popup-open]');
    if (!dialog || !trigger) return false;
    if (dialog.open && dialog.getBoundingClientRect().width > 0) return true; // already showing

    // The theme hides the pop-up (display:none !important) when an in-stock
    // size is selected. Override that while the pop-up is open, keep the
    // "Sold out" button itself hidden, and put everything back on close.
    var forced = window.getComputedStyle(modal).display === 'none';
    var hiddenSiblings = [];
    if (forced) {
      modal.style.setProperty('display', 'block', 'important');
      Array.prototype.forEach.call(modal.children, function (child) {
        if (child !== dialog) {
          hiddenSiblings.push([child, child.style.display]);
          child.style.setProperty('display', 'none', 'important');
        }
      });
      dialog.addEventListener('close', function () {
        modal.style.removeProperty('display');
        hiddenSiblings.forEach(function (pair) {
          pair[0].style.removeProperty('display');
          if (pair[1]) pair[0].style.display = pair[1];
        });
      }, { once: true });
    }

    // Clear #notify-me from the address bar when the pop-up closes
    dialog.addEventListener('close', function () {
      if (window.location.hash === LINK_HASH && window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    }, { once: true });

    if (dialog.open) return true; // was open but hidden by the theme – now visible

    trigger.click();

    // Fallback: if the theme's pop-up script hasn't attached yet, open the dialog directly
    if (!dialog.open && typeof dialog.showModal === 'function') {
      try {
        dialog.showModal();
        var closeBtn = dialog.querySelector('[data-popup-close]');
        if (closeBtn) {
          closeBtn.addEventListener('click', function () {
            if (dialog.open) dialog.close();
          }, { once: true });
        }
      } catch (e) {
        return false;
      }
    }
    return dialog.open;
  }
  window.openNotifyMe = openNotifyMe;

  document.addEventListener('click', function (evt) {
    var link = evt.target.closest && evt.target.closest('a[href$="' + LINK_HASH + '"]');
    if (!link) return;
    if (openNotifyMe()) evt.preventDefault();
  });

  // Opening from a URL ending in #notify-me: keep trying for up to 10 seconds
  var hashTimer = null;
  function openFromHash() {
    if (window.location.hash !== LINK_HASH || hashTimer) return;
    var attempts = 0;
    hashTimer = setInterval(function () {
      attempts++;
      var opened = false;
      try { opened = openNotifyMe(); } catch (e) { console.error(e); }
      if (opened || attempts >= 40) {
        clearInterval(hashTimer);
        hashTimer = null;
      }
    }, 250);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openFromHash);
  } else {
    openFromHash();
  }
  window.addEventListener('hashchange', openFromHash);

  /* ---------- The form ---------- */
  if (customElements.get('notify-me-klavio')) return;

  customElements.define('notify-me-klavio', class extends HTMLElement {
    constructor() {
      super();
      this.companyId = this.dataset.companyId;
      this.smsId = this.dataset.smsId;
      this.hasSMS = !!this.smsId;
      this.emailId = this.dataset.emailId;
      this.sizeInputs = [];
      this.sizeNames = {};

      // Which channels the phone number is used for (SMS, WHATSAPP or both)
      this.phoneChannels = (this.dataset.phoneChannels || 'SMS')
        .split(',')
        .map(function (c) { return c.trim().toUpperCase(); })
        .filter(function (c) { return c === 'SMS' || c === 'WHATSAPP'; });
      if (!this.phoneChannels.length) this.phoneChannels = ['SMS'];
      this.phoneLabel = this.phoneChannels
        .map(function (c) { return c === 'SMS' ? 'SMS' : 'WhatsApp'; })
        .join(' and ');

      this.activeChannel = this.hasSMS && this.dataset.defaultChannel !== 'email' ? 'phone' : 'email';

      this.form = this.querySelector('.notify-me-form');
      this.submitbtn = this.querySelector('[data-kalvyio-submit]');
      this.form.addEventListener('submit', this.submitBIS.bind(this));

      // Channel toggle
      this.querySelectorAll('[data-nm-channel]').forEach((tab) => {
        tab.addEventListener('click', () => this.setChannel(tab.dataset.nmChannel, true));
      });

      // Clear the consent warning as soon as the box is ticked
      var consentSMS = this.querySelector('[data-notify-consent-sms]');
      if (consentSMS) {
        consentSMS.addEventListener('change', () => {
          if (consentSMS.checked) this.querySelector('.consent-warning-msg').innerHTML = '';
        });
      }

      // "Continue browsing" on the success screen
      var done = this.querySelector('[data-nm-done]');
      if (done) {
        done.addEventListener('click', () => {
          var close = this.querySelector('.product-modal__close');
          if (close) close.click();
        });
      }
    }

    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      this.setDefaultCountry();
      this.setChannel(this.activeChannel, false);
      this.buildSizePicker();

      var dialog = this.closest('dialog');
      if (dialog) {
        // Re-tick the currently selected size every time the pop-up opens
        new MutationObserver(() => {
          if (dialog.open) this.syncSelectedSize();
        }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
        // Reset to the form after a successful sign-up once closed
        dialog.addEventListener('close', () => this.resetAfterSuccess());
      }
    }

    setDefaultCountry() {
      var select = this.querySelector('.country-code');
      if (!select || select.value) return;
      var code = (this.dataset.defaultCountry || 'GB').toUpperCase();
      var option = select.querySelector('option[data-countrycode="' + code + '"]');
      if (option) select.value = option.value;
    }

    setChannel(channel, focusField) {
      if (channel === 'phone' && !this.hasSMS) channel = 'email';
      this.activeChannel = channel;
      this.querySelectorAll('[data-nm-channel]').forEach(function (tab) {
        tab.setAttribute('aria-selected', tab.dataset.nmChannel === channel ? 'true' : 'false');
      });
      this.querySelectorAll('[data-nm-panel]').forEach(function (panel) {
        panel.hidden = panel.dataset.nmPanel !== channel;
      });
      this.clearMessages();
      if (focusField) {
        var field = this.querySelector(channel === 'phone' ? '#tel-number' : '#email');
        if (field) field.focus();
      }
    }

    clearMessages() {
      this.querySelectorAll('.notify-me-error').forEach(function (el) { el.innerHTML = ''; });
    }

    currentVariantId() {
      var el = this.querySelector('[data-notify-me-variant]');
      return el && el.dataset.variantId ? String(el.dataset.variantId) : null;
    }

    buildSizePicker() {
      var handle = productHandle();
      var holder = this.querySelector('[data-nm-sizes]');
      if (!handle || !holder) return;

      fetch('/products/' + handle + '.js')
        .then((res) => res.json())
        .then((product) => {
          if (!product.variants || product.variants.length < 2) return; // single-size product

          var variants = product.variants.slice().sort(function (a, b) {
            var ia = SIZE_ORDER.indexOf(shortSizeLabel(a.title));
            var ib = SIZE_ORDER.indexOf(shortSizeLabel(b.title));
            return (ia === -1 ? 99 : ia) - (ib === -1 ? 99 : ib);
          });
          var soldOut = variants.filter(function (v) { return !v.available; });
          var inStock = variants.filter(function (v) { return v.available; });

          var fieldset = document.createElement('fieldset');
          fieldset.className = 'nm-sizes';

          var legend = document.createElement('legend');
          legend.textContent = TEXT.sizeHeading;
          if (soldOut.length > 1) {
            var hint = document.createElement('small');
            hint.textContent = TEXT.sizeHint;
            legend.appendChild(hint);
          }
          fieldset.appendChild(legend);

          if (soldOut.length) {
            var options = document.createElement('div');
            options.className = 'nm-sizes__options';
            soldOut.forEach((variant) => {
              var name = shortSizeLabel(variant.title);
              this.sizeNames[String(variant.id)] = name;

              var label = document.createElement('label');
              label.className = 'nm-size';
              label.title = variant.title;
              var input = document.createElement('input');
              input.type = 'checkbox';
              input.name = 'notify-sizes';
              input.value = String(variant.id);
              var span = document.createElement('span');
              span.textContent = name;
              label.appendChild(input);
              label.appendChild(span);
              options.appendChild(label);
              this.sizeInputs.push(input);
            });
            fieldset.appendChild(options);
          }

          var note = document.createElement('p');
          note.className = 'nm-instock-note';
          if (!soldOut.length) note.textContent = TEXT.allInStock;
          else if (inStock.length) note.textContent = TEXT.inStockNote(joinList(inStock.map(function (v) { return shortSizeLabel(v.title); })));
          if (note.textContent) fieldset.appendChild(note);

          var sizeError = document.createElement('div');
          sizeError.className = 'size-error-msg notify-me-error';
          fieldset.appendChild(sizeError);

          holder.appendChild(fieldset);
          this.syncSelectedSize();
        })
        .catch((err) => console.error('Back in stock sizes failed to load', err));
    }

    syncSelectedSize() {
      if (!this.sizeInputs.length) return;
      var current = this.currentVariantId();
      var anyMatch = this.sizeInputs.some(function (input) { return input.value === current; });
      this.sizeInputs.forEach((input) => {
        // Tick the size being viewed; if it's in stock and only one size is sold out, tick that one
        input.checked = anyMatch ? input.value === current : this.sizeInputs.length === 1;
      });
    }

    selectedVariantIds() {
      if (!this.sizeInputs.length) {
        // Single-size product, or sizes couldn't load: use the variant on the page
        return this.querySelector('.nm-sizes') ? [] : [this.currentVariantId()].filter(Boolean);
      }
      return this.sizeInputs.filter(function (i) { return i.checked; }).map(function (i) { return i.value; });
    }

    submitBIS(evt) {
      evt.preventDefault();
      this.clearMessages();

      const variantIds = this.selectedVariantIds();
      if (!variantIds.length) {
        const sizeErr = this.querySelector('.size-error-msg') || this.querySelector('.general-error-msg');
        sizeErr.innerHTML = TEXT.noSize;
        return;
      }

      let channels;
      let profileAttributes;
      let consentFn = null;

      if (this.activeChannel === 'phone') {
        const telNumber = this.querySelector('#tel-number');
        const countryCode = this.querySelector('.country-code');
        const consentSMS = this.querySelector('[data-notify-consent-sms]');
        const phoneErr = this.querySelector('.phone-error-msg');
        const digits = (telNumber.value || '').replace(/\D/g, '').replace(/^0+/, '');

        if (!countryCode.value) { phoneErr.innerHTML = TEXT.noCountry; countryCode.focus(); return; }
        if (digits.length < 7 || digits.length > 14) { phoneErr.innerHTML = TEXT.badPhone; telNumber.focus(); return; }
        if (!consentSMS.checked) {
          this.querySelector('.consent-warning-msg').innerHTML = TEXT.needConsent(this.phoneLabel);
          return;
        }
        channels = this.phoneChannels.slice();
        profileAttributes = { phone_number: '+' + countryCode.value + digits };
        consentFn = () => this.consentSMS(profileAttributes.phone_number);
        this.lastPhoneCountry = countryCode.value;
      } else {
        const email = this.querySelector('#email');
        const consent = this.querySelector('[data-notify-consent]');
        const emailErr = this.querySelector('.email-error-msg');
        const value = (email.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) { emailErr.innerHTML = TEXT.badEmail; email.focus(); return; }
        channels = ['EMAIL'];
        profileAttributes = { email: value };
        if (consent && consent.checked) consentFn = () => this.consent(value);
      }

      this.submitbtn.disabled = true;
      this.postBIS(variantIds, channels, profileAttributes)
        .then((ok) => {
          if (ok) {
            if (consentFn) consentFn();
            this.showSuccess(variantIds, profileAttributes);
            return;
          }
          this.querySelector('.general-error-msg').innerHTML = TEXT.failed;
        })
        .catch((error) => {
          console.log('error', error);
          this.querySelector('.general-error-msg').innerHTML = TEXT.failed;
        })
        .finally(() => {
          this.submitbtn.disabled = false;
        });
    }

    // Klaviyo takes one variant per request, so send one per size. Resolves true if all succeeded.
    postBIS(variantIds, channels, profileAttributes) {
      const requests = variantIds.map((variantId) => {
        const payload = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: { data: { type: 'profile', attributes: profileAttributes } },
              channels: channels
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${variantId}` } }
            }
          }
        };
        return fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + this.companyId, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-06-15' },
          body: JSON.stringify(payload)
        });
      });
      return Promise.all(requests).then((results) => results.every((r) => r.status === 202));
    }

    showSuccess(variantIds, profileAttributes) {
      this.lastSignup = {
        variantIds: variantIds,
        channel: this.activeChannel,
        profile: Object.assign({}, profileAttributes || {})
      };
      this.buildExtra();
      this.loadRecs(variantIds);

      const names = variantIds.map((id) => this.sizeNames[id]).filter(Boolean);
      const sizes = names.length ? 'the ' + joinList(names) + (names.length > 1 ? ' sizes' : ' size') : 'it';
      const text = this.activeChannel === 'phone'
        ? TEXT.successPhone(this.phoneLabel, sizes)
        : TEXT.successEmail(sizes);
      const box = this.querySelector('[data-nm-success]');
      if (!box) {
        this.querySelector('.success-msg').innerHTML = text;
        return;
      }
      box.querySelector('[data-nm-success-text]').textContent = text;
      this.form.hidden = true;
      box.hidden = false;
      this.succeeded = true;
      const done = box.querySelector('[data-nm-done]');
      if (done) done.focus();
    }

    resetAfterSuccess() {
      if (!this.succeeded) return;
      this.succeeded = false;
      const box = this.querySelector('[data-nm-success]');
      if (box) box.hidden = true;
      this.form.hidden = false;
      this.clearMessages();
      const extra = this.querySelector('[data-nm-extra]');
      if (extra) { extra.hidden = true; extra.innerHTML = ''; }
      const recs = this.querySelector('[data-nm-recs]');
      if (recs) { recs.hidden = true; recs.querySelector('[data-nm-recs-grid]').innerHTML = ''; }
    }

    /* ---------- Version C: add the other channel ---------- */
    buildExtra() {
      const extra = this.querySelector('[data-nm-extra]');
      if (!extra || !this.lastSignup) return;
      extra.innerHTML = '';
      const wantPhone = this.lastSignup.channel === 'email';
      if (wantPhone && !this.hasSMS) { extra.hidden = true; return; }

      const el = (tag, cls, text) => {
        const n = document.createElement(tag);
        if (cls) n.className = cls;
        if (text) n.textContent = text;
        return n;
      };
      const form = el('form', 'nm-extra__form');
      form.noValidate = true;
      const title = el('p', 'nm-extra__title', wantPhone ? TEXT.extraPhoneTitle(this.phoneLabel) : TEXT.extraEmailTitle);
      const sub = el('p', 'nm-extra__sub', wantPhone ? TEXT.extraPhoneSub(this.phoneLabel) : TEXT.extraEmailSub);
      const row = el('div', 'nm-extra__row');
      // Re-use the exact consent box from the first step of the form, so the wording always matches
      const sourceConsent = this.querySelector('[data-nm-panel="' + (wantPhone ? 'phone' : 'email') + '"] .nm-consent');
      const consentLabel = sourceConsent ? sourceConsent.cloneNode(true) : el('label', 'nm-consent');
      let consentBox = consentLabel.querySelector('input[type="checkbox"]');
      if (!consentBox) {
        consentBox = document.createElement('input');
        consentBox.type = 'checkbox';
        consentLabel.appendChild(consentBox);
      }
      ['id', 'name', 'data-notify-consent', 'data-notify-consent-sms'].forEach((attr) => consentBox.removeAttribute(attr));
      consentBox.checked = false;
      const error = el('div', 'notify-me-error nm-extra__error');
      error.setAttribute('role', 'alert');
      const btn = el('button', 'btn btn--secondary btn--outline nm-extra__btn', wantPhone ? TEXT.extraPhoneBtn : TEXT.extraEmailBtn);
      btn.type = 'submit';

      let field;
      let select = null;
      if (wantPhone) {
        const original = this.querySelector('[data-nm-panel="phone"] .country-code');
        select = original ? original.cloneNode(true) : document.createElement('select');
        select.removeAttribute('id');
        select.removeAttribute('name');
        select.value = original ? original.value : '';
        select.setAttribute('aria-label', 'Country code');
        field = document.createElement('input');
        field.type = 'tel';
        field.inputMode = 'tel';
        field.autocomplete = 'tel-national';
        field.placeholder = 'Mobile number';
        field.setAttribute('aria-label', 'Mobile number');
        row.appendChild(select);
      } else {
        field = document.createElement('input');
        field.type = 'email';
        field.autocomplete = 'email';
        field.placeholder = 'you@example.com';
        field.setAttribute('aria-label', 'Email address');
      }
      row.appendChild(field);

      form.appendChild(row);
      form.appendChild(consentLabel);
      form.appendChild(btn);
      form.appendChild(error);
      extra.appendChild(title);
      extra.appendChild(sub);
      extra.appendChild(form);
      extra.hidden = false;

      form.addEventListener('submit', (evt) => {
        evt.preventDefault();
        error.textContent = '';
        const profile = Object.assign({}, this.lastSignup.profile);
        let channels;
        let after = null;

        if (wantPhone) {
          const digits = (field.value || '').replace(/\D/g, '').replace(/^0+/, '');
          if (!select.value) { error.textContent = TEXT.noCountry; select.focus(); return; }
          if (digits.length < 7 || digits.length > 14) { error.textContent = TEXT.badPhone; field.focus(); return; }
          if (!consentBox.checked) { error.textContent = TEXT.needConsent(this.phoneLabel); return; }
          profile.phone_number = '+' + select.value + digits;
          channels = this.phoneChannels.slice();
          after = () => this.consentSMS(profile.phone_number);
        } else {
          const value = (field.value || '').trim();
          if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) { error.textContent = TEXT.badEmail; field.focus(); return; }
          profile.email = value;
          channels = ['EMAIL'];
          if (consentBox.checked) after = () => this.consent(value);
        }

        btn.disabled = true;
        this.postBIS(this.lastSignup.variantIds, channels, profile)
          .then((ok) => {
            if (!ok) { error.textContent = TEXT.failed; return; }
            if (after) after();
            this.lastSignup.profile = profile;
            extra.innerHTML = '';
            extra.appendChild(el('p', 'nm-extra__done', '✓ ' + (wantPhone ? TEXT.extraPhoneDone(this.phoneLabel) : TEXT.extraEmailDone)));
          })
          .catch(() => { error.textContent = TEXT.failed; })
          .finally(() => { btn.disabled = false; });
      });
    }

    /* ---------- Version C: Don't want to wait? ---------- */
    loadRecs(variantIds) {
      const box = this.querySelector('[data-nm-recs]');
      if (!box) return;
      const sizeName = this.sizeNames[variantIds[0]];
      if (!sizeName) return; // single-size product – nothing size-specific to suggest

      const colour = this.dataset.colourCollection;
      const colourTitle = this.dataset.colourTitle;

      const fromColour = colour
        ? fetch('/collections/' + colour + '?sort_by=best-selling&sections=nm-recs')
            .then((r) => r.json())
            .then((json) => {
              const holder = document.createElement('div');
              holder.innerHTML = json['nm-recs'] || '';
              const script = holder.querySelector('[data-nm-recs-json]');
              return script ? JSON.parse(script.textContent).filter(Boolean) : [];
            })
            .catch(() => [])
        : Promise.resolve([]);

      fromColour
        .then((list) => {
          const picks = this.pickRecs(list, sizeName);
          if (picks.length) return { picks: picks, colour: true };
          return fetch('/recommendations/products.json?product_id=' + this.dataset.productId + '&limit=10&intent=related')
            .then((r) => r.json())
            .then((json) => ({ picks: this.pickRecs((json.products || []).map(this.normaliseRec), sizeName), colour: false }))
            .catch(() => ({ picks: [], colour: false }));
        })
        .then((result) => {
          if (!result.picks.length) return;
          box.querySelector('[data-nm-recs-sub]').textContent = result.colour && colourTitle
            ? TEXT.recsSubColour(sizeName, colourTitle)
            : TEXT.recsSub(sizeName);
          const grid = box.querySelector('[data-nm-recs-grid]');
          grid.innerHTML = '';
          result.picks.forEach((pick) => grid.appendChild(this.recCard(pick)));
          box.hidden = false;
        });
    }

    normaliseRec(p) {
      let currency = 'GBP';
      try { currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP'; } catch (e) {}
      const fmt = (cents) => {
        try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: currency }).format(cents / 100); }
        catch (e) { return ''; }
      };
      return {
        handle: p.handle,
        title: p.title,
        url: p.url,
        image: p.featured_image || (p.images && p.images[0]) || null,
        tags: p.tags || [],
        variants: (p.variants || []).map((v) => ({ id: v.id, title: v.title, available: v.available, price: fmt(v.price) }))
      };
    }

    pickRecs(list, sizeName) {
      const currentHandle = this.dataset.productHandle;
      const groupTag = this.dataset.groupTag;
      const seenGroups = {};
      if (groupTag) seenGroups[groupTag] = true;
      const picks = [];
      for (let i = 0; i < list.length && picks.length < TEXT.recsCount; i++) {
        const p = list[i];
        if (!p || p.handle === currentHandle) continue;
        const tags = p.tags || [];
        const group = tags.filter((t) => String(t).indexOf('YGroup_') === 0)[0];
        if (group && seenGroups[group]) continue; // other side of a mat we've already shown
        const variant = (p.variants || []).filter((v) => v.available && shortSizeLabel(v.title) === sizeName)[0];
        if (!variant) continue;
        if (group) seenGroups[group] = true;
        picks.push({ product: p, variant: variant });
      }
      return picks;
    }

    recCard(pick) {
      const a = document.createElement('a');
      a.className = 'nm-rec';
      a.href = pick.product.url + (pick.product.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + pick.variant.id;
      if (pick.product.image) {
        const img = document.createElement('img');
        let src = pick.product.image;
        if (src.indexOf('width=') === -1) src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=400';
        img.src = src;
        img.alt = '';
        img.loading = 'lazy';
        a.appendChild(img);
      }
      const title = document.createElement('span');
      title.className = 'nm-rec__title';
      title.textContent = pick.product.title.replace(/\s+Playmat$/i, '');
      a.appendChild(title);
      if (pick.variant.price) {
        const price = document.createElement('span');
        price.className = 'nm-rec__price';
        price.textContent = pick.variant.price;
        a.appendChild(price);
      }
      return a;
    }

    consent(emailAddress) {
      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: emailAddress,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: this.emailId } } }
        }
      };
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + this.companyId, {
        method: 'POST',
        headers: { revision: '2025-01-15', 'content-type': 'application/vnd.api+json' },
        body: JSON.stringify(payload)
      }).catch((err) => console.error(err));
    }

    consentSMS(phoneNumber) {
      if (!this.hasSMS) return;
      // Consent for each phone channel this store uses (SMS and/or WhatsApp)
      const subscriptions = {};
      if (this.phoneChannels.indexOf('SMS') !== -1) {
        subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' }, transactional: { consent: 'SUBSCRIBED' } };
      }
      if (this.phoneChannels.indexOf('WHATSAPP') !== -1) {
        subscriptions.whatsapp = { marketing: { consent: 'SUBSCRIBED' }, transactional: { consent: 'SUBSCRIBED' } };
      }
      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: { phone_number: phoneNumber, subscriptions: subscriptions }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: this.smsId } } }
        }
      };
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + this.companyId, {
        method: 'POST',
        headers: { revision: '2025-01-15', 'content-type': 'application/vnd.api+json' },
        body: JSON.stringify(payload)
      }).catch((err) => console.error(err));
    }
  });
})();
